import { useEffect } from "react";

import { hideSmartBanner, observeSmartBanner } from "@/utils/smartBanner";

export const useHideSmartBanner = () => {
    useEffect(() => {
        return observeSmartBanner(hideSmartBanner);
    }, []);
};
